/* Кнопки — одна система по всему продукту: обычная той же высоты, что поле ввода (40 px), маленькая — 34 px,
   кнопка-значок — 36 px. Тексту просторно: по 18 и 14 px по бокам. */
.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 40px;
  padding: 0 18px;
  border: 1px solid transparent;
  border-radius: var(--radius-sm); /* как у полей ввода — одна величина скругления для кнопок и полей */
  font: inherit;
  font-size: var(--fs-15, 15px);
  line-height: var(--lh-20, 20px);
  font-weight: var(--w-button);
  cursor: pointer;
  white-space: nowrap;
  text-decoration: none;
  transition:
    background var(--dur-fast),
    border-color var(--dur-fast),
    box-shadow var(--dur-fast),
    opacity var(--dur-fast),
    transform var(--dur-instant) var(--ease-out);
}
/* Нажатие — кнопка чуть «поддаётся», как физическая (Apple, Linear); широкая — едва заметно, чтобы не «дышала». */
.button:active:not(:disabled) {
  transform: scale(0.97);
}
.block:active:not(:disabled) {
  transform: scale(0.99);
}
/*
 * Кнопка ждёт ответа: ширина не меняется, кнопка не бледнеет. Крутилка встаёт на место подписи только через 300 мс —
 * быстрый ответ проходит без мигания (NN/g: до 0,1–1 с индикатор не нужен).
 */
.button[aria-busy='true'] {
  position: relative;
  cursor: progress;
}
.button[aria-busy='true']:disabled {
  opacity: 1;
}
.button > .spinner {
  position: absolute;
  inset: 0;
  margin: auto;
  width: 16px;
  height: 16px;
  animation:
    spin 0.7s linear infinite,
    busy-in var(--dur-fast) var(--ease-out) 300ms both;
}
.busyLabel {
  display: inline-flex;
  align-items: center;
  gap: inherit;
  animation: busy-out var(--dur-fast) 300ms both;
}
@keyframes busy-in {
  from {
    opacity: 0;
  }
}
@keyframes busy-out {
  to {
    opacity: 0;
  }
}
.button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
/*
 * Едва заметный объём, как на passwork.ru, только тише: светлая кромка сверху, лёгкий перелив сверху вниз
 * и мягкая тень того же цвета. Цвет кнопки задаёт background-color, перелив лежит поверх.
 */
.primary {
  background-color: var(--accent);
  background-image: linear-gradient(rgb(255 255 255 / 7%), rgb(255 255 255 / 0%));
  color: var(--accent-text);
  box-shadow:
    inset 0 1px 0 rgb(255 255 255 / 14%),
    0 1px 2px rgb(20 40 90 / 12%),
    0 3px 8px -3px color-mix(in srgb, var(--accent) 45%, transparent);
}
.primary:hover:not(:disabled) {
  background-color: var(--accent-hover);
}
.primary:active:not(:disabled) {
  box-shadow:
    inset 0 1px 0 rgb(255 255 255 / 8%),
    0 1px 1px rgb(20 40 90 / 10%);
}
/* Вторичная кнопка — как на сайте Пассворка: светло-синяя с синей рамкой. */
.secondary {
  background: var(--surface);
  color: var(--text);
  border-color: var(--border-strong);
  box-shadow: 0 1px 2px rgb(20 30 50 / 5%);
}
.secondary:hover:not(:disabled) {
  background: var(--surface-2);
  border-color: color-mix(in srgb, var(--accent) 40%, var(--border-strong));
}
.ghost {
  background: transparent;
  color: var(--accent-ink);
}
.ghost:hover:not(:disabled) {
  background: var(--surface-2);
}
.danger {
  background-color: var(--danger);
  background-image: linear-gradient(rgb(255 255 255 / 7%), rgb(255 255 255 / 0%));
  color: #fff;
  box-shadow:
    inset 0 1px 0 rgb(255 255 255 / 14%),
    0 1px 2px rgb(90 20 20 / 12%),
    0 3px 8px -3px color-mix(in srgb, var(--danger) 45%, transparent);
}
.danger:hover:not(:disabled) {
  background-color: color-mix(in srgb, var(--danger) 88%, #000);
}
.small {
  min-height: 34px;
  padding: 0 14px;
  font-size: var(--fs-14, 14px);
  border-radius: var(--radius-sm);
}
/* Кнопка со значком перед текстом: у значка свои поля внутри рисунка, поэтому слева отступ меньше — на глаз
   от края до значка столько же, сколько от текста до правого края. Линия значка — как толщина букв кнопки. */
.button:has(> svg:first-child):not(.icon) {
  padding-left: 14px;
  gap: 7px;
}
.small:has(> svg:first-child):not(.icon) {
  padding-left: 10px;
  gap: 6px;
}
.button:not(.icon) > svg {
  stroke-width: 2.1;
}
.icon {
  min-height: 36px;
  width: 36px;
  padding: 0;
  color: var(--text-2);
  border-radius: var(--radius-sm);
}
.icon:hover:not(:disabled) {
  background: var(--surface-2);
  color: var(--text);
}
.block {
  width: 100%;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
/* Подписи полей — обычным регистром, как в Пассворке и Slack. */
.label {
  font-size: var(--fs-13);
  line-height: 18px;
  font-weight: var(--w-medium);
  color: var(--text);
}
.input {
  width: 100%;
  min-height: 40px;
  padding: 8px 12px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: var(--surface-2);
  color: var(--text);
  font: inherit;
  font-size: var(--fs-15, 15px);
  transition: border-color var(--dur-fast), box-shadow var(--dur-fast), background var(--dur-fast);
}
.input::placeholder {
  color: var(--placeholder);
}
.input:hover:not(:focus) {
  border-color: color-mix(in srgb, var(--text) 30%, var(--border-strong));
}
select.input {
  appearance: none;
  padding-right: 36px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath d='M2.5 4.5 6 8l3.5-3.5' fill='none' stroke='%23858585' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 12px;
  cursor: pointer;
}
.input:focus {
  border-color: var(--accent);
  background: var(--surface);
  outline: none;
  box-shadow: var(--focus);
}
.input[aria-invalid='true'] {
  border-color: var(--danger);
}
.hint {
  font-size: var(--fs-13);
  color: var(--muted);
}
.error {
  font-size: var(--fs-13);
  color: var(--danger);
}

.alert {
  padding: 10px 14px;
  border-radius: 10px;
  font-size: var(--fs-14, 14px);
}
.alertError {
  background: var(--danger-soft);
  color: var(--danger);
}
.alertSuccess {
  background: var(--success-soft);
  color: var(--success);
}
.alertInfo {
  background: var(--accent-soft);
  color: var(--text);
}
.alertWarning {
  background: var(--warning-soft);
  color: var(--text);
}

.card {
  display: flex;
  flex-direction: column;
  gap: 14px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 20px 22px;
  min-width: 0;
}
.cardTitle {
  font-size: var(--fs-18);
  line-height: 24px;
  font-weight: var(--w-bold);
  letter-spacing: -0.01em;
}

.stack {
  display: flex;
  flex-direction: column;
  gap: var(--gap);
}
.row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}

.pageHeader {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.pageActions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  align-items: center;
  min-width: 0;
}
.pageTitle {
  font-size: 24px;
  font-weight: var(--w-bold);
  letter-spacing: -0.01em;
  text-wrap: balance;
}

.dialog {
  /* Окно светлее страницы, поля — темнее окна, как в Пассворке (в светлой теме — те же белый и серый). */
  --surface: var(--dialog-bg);
  --surface-2: var(--dialog-field);
  --border: var(--dialog-border);
  /* Окно может жить внутри шапки, прозрачной для нажатий на телефоне, — само оно нажимается всегда. */
  pointer-events: auto;
  width: min(560px, calc(100vw - 32px));
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 0;
  border: 0;
  border-radius: 14px;
  box-shadow: 0 24px 64px rgb(20 24 32 / 28%), 0 0 0 1px rgb(20 24 32 / 6%);
  background: var(--surface);
  color: var(--text);
}
.dialog:focus:not(:focus-visible) {
  outline: none;
}
.dialog[open] {
  animation: rise var(--dur-base) var(--ease);
}
@keyframes rise {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.985);
  }
}
.dialog::backdrop {
  background: var(--backdrop);
}
.dialog[open]::backdrop {
  animation: fadeIn var(--dur-base) ease;
}
.dialogClosing[open] {
  animation: fall var(--dur-fast) ease forwards;
}
.dialogClosing[open]::backdrop {
  animation: fadeOut var(--dur-fast) ease forwards;
}
@keyframes fall {
  to {
    opacity: 0;
    transform: translateY(4px) scale(0.985);
  }
}
/* Окно из значка: вырастает из точки, куда нажали, и сворачивается в неё же (transform-origin ставит Dialog). */
.dialogFrom[open] {
  animation: growFrom var(--dur-slow) var(--ease-out);
}
.dialogFrom.dialogClosing[open] {
  animation: shrinkTo var(--dur-base) var(--ease-in) forwards;
}
@keyframes growFrom {
  from {
    opacity: 0;
    transform: scale(0.12);
  }
}
@keyframes shrinkTo {
  to {
    opacity: 0;
    transform: scale(0.12);
  }
}
@keyframes fadeOut {
  to {
    opacity: 0;
  }
}
.dialogBody {
  --dlg-pt: 22px;
  --dlg-pb: 28px;
  padding: var(--dlg-pt) 28px var(--dlg-pb);
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: var(--gap);
}
/* Окно-просмотр: заголовок и крестик ближе к верху. */
.dialogTight.dialogTight {
  --dlg-pt: 10px;
  --dlg-pb: 20px;
  padding: var(--dlg-pt) 20px var(--dlg-pb);
}
/* Кнопки окна — слева, главная первой, как во всём Пассворке. */
.dialogActions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  margin-top: 4px;
}
@media (max-width: 767px) {
  .dialogActions {
    flex-direction: column;
    align-items: stretch;
  }
  .dialogActions > * {
    width: 100%;
  }
}
.dialogHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* Заголовок и крестик всегда на месте: при прокрутке окна уезжает только содержимое. */
  position: sticky;
  top: 0;
  z-index: 3;
  margin-top: calc(-1 * var(--dlg-pt));
  padding-top: var(--dlg-pt);
  padding-bottom: 4px;
  background: var(--surface);
}
/* Кнопки действий тоже закреплены внизу окна: их нельзя прокрутить за край. Положение без прокрутки не меняется. */
.dialog:not(.dialogBare) [data-dialog-actions] {
  position: sticky;
  bottom: 0;
  z-index: 3;
  margin-top: -4px;
  margin-bottom: calc(-1 * var(--dlg-pb));
  padding-top: 8px;
  padding-bottom: var(--dlg-pb);
  background: var(--surface);
}
.dialogTitleRow {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.tableWrap {
  position: relative;
  width: 100%;
  overflow-x: auto;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--surface);
}
.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13.5px;
  font-variant-numeric: tabular-nums;
}
.table th {
  text-align: left;
  font-size: var(--fs-12);
  font-weight: var(--w-bold);
  color: var(--muted);
  padding: 10px 14px;
  border-bottom: 1px solid var(--border);
  white-space: nowrap;
  background: var(--surface);
}
.table td {
  padding: 9px 14px;
  border-bottom: 1px solid var(--border);
  vertical-align: middle;
}
.table tbody tr:hover td {
  background: var(--surface-2);
}
.table tr:last-child td {
  border-bottom: none;
}

.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 48px 20px;
  text-align: center;
  color: var(--text-2);
  /* Пустой экран мягко проявляется, значок — с лёгкой пружинкой (Things, Linear): не голая строка, а ответ. */
  animation: empty-in var(--dur-slow) var(--ease-out);
  /* По центру свободной области (там, где у родителя есть высота), оптический центр — чуть выше, как в Notion и Linear. */
  flex: 1 1 auto;
  min-height: 0;
  box-sizing: border-box;
  justify-content: center;
  padding-bottom: max(64px, 8%);
}
.emptyIcon {
  width: 60px;
  height: 60px;
  display: grid;
  place-items: center;
  margin-bottom: 4px;
  border-radius: 16px;
  background: var(--accent-soft);
  color: var(--accent-ink);
  animation: empty-icon var(--dur-slow) var(--ease-spring);
}
@keyframes empty-in {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
}
@keyframes empty-icon {
  from {
    transform: scale(0.85);
  }
}
.emptyTitle {
  margin: 0;
  font-size: var(--fs-18);
  line-height: 24px;
  font-weight: var(--w-bold);
  color: var(--text);
}
.emptyText {
  max-width: 420px;
  margin: 0 0 6px;
}

.spinnerBlock {
  display: flex;
  justify-content: center;
  padding: 56px 0;
  color: var(--text-3, var(--text-2));
}
.spinnerInline {
  display: inline-flex;
  align-items: center;
}
.spinner {
  width: 22px;
  height: 22px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: var(--fs-12);
  font-weight: var(--w-bold);
  background: var(--surface-2);
  color: var(--muted);
}

.checkbox {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: var(--fs-14, 14px);
  cursor: pointer;
  min-height: 32px;
}
.checkbox input {
  width: 18px;
  height: 18px;
  accent-color: var(--accent);
}
/* Заблокированный — серый и без руки: сразу видно, что не нажать. */
.checkbox:has(input:disabled) {
  cursor: not-allowed;
  opacity: 0.45;
}

/* Высота как у поля ввода и кнопки (40 px) — в одной строке всё вровень. */
.segmented {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: stretch;
  min-height: 40px;
  padding: 3px;
  gap: 2px;
  border-radius: var(--radius-sm);
  background: var(--seg-track);
  border: 1px solid var(--seg-border);
  box-sizing: border-box;
  max-width: 100%;
}
.segmentedStretch {
  display: flex;
  width: 100%;
}
.segmentedStretch > * {
  flex: 1 1 0;
  justify-content: center;
}
.segment,
.segmentActive {
  border: 0;
  border-radius: 6px;
  padding: 4px 12px;
  font: inherit;
  font-size: var(--fs-14, 14px);
  font-weight: var(--w-medium);
  cursor: pointer;
  background: transparent;
  color: var(--text-2);
  white-space: nowrap;
}
.segment:focus:not(:focus-visible),
.segmentActive:focus:not(:focus-visible) {
  outline: none;
}
.segment:hover {
  /* Наведение — только лёгкий тон без рамки и тени: выбранная плашка приподнята и с рамкой, их не спутать. */
  color: var(--text);
  background: color-mix(in srgb, var(--text) 6%, transparent);
}
/* Сегмент со значком: значок и подпись в одну строку. */
.segment:has(> svg),
.segmentActive:has(> svg) {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding-left: 10px;
}
/* Узкий телефон: значки сегментов прячутся, подписи остаются в одну строку. */
@media (max-width: 480px) {
  .segment > svg,
  .segmentActive > svg {
    display: none;
  }
  .segment:has(> svg),
  .segmentActive:has(> svg) {
    padding-left: 12px;
  }
}
.segmentedCompact {
  min-height: 28px;
  padding: 2px;
  gap: 2px;
}
.segmentedCompact > .segment,
.segmentedCompact > .segmentActive {
  padding: 2px 10px;
  font-size: var(--fs-13, 13px);
}
.segmentedIcons {
  flex-wrap: nowrap;
  min-height: var(--tool-h, 30px);
  padding: 2px;
  gap: 2px;
}
.segmentedIcons > .segment,
.segmentedIcons > .segmentActive {
  display: inline-grid;
  place-items: center;
  width: 30px;
  padding: 0;
}
.segmentedCompact.segmentedIcons {
  min-height: 28px;
}
.segmentedCompact.segmentedIcons > .segment,
.segmentedCompact.segmentedIcons > .segmentActive {
  width: 28px;
}
.segmentedIcons > .segment > svg,
.segmentedIcons > .segmentActive > svg {
  display: block;
}
.segmentActive {
  /* Выбранное — приподнятая плашка с рамкой, без жирного: ширина не меняется, ничего не прыгает. */
  background: var(--seg-lift);
  color: var(--text);
  box-shadow: inset 0 0 0 1px var(--seg-lift-border), var(--seg-lift-shadow);
}
/*
 * Плашка выбранного переезжает к новому сегменту (useSlidingIndicator): пока место не измерено, плашкой служит
 * сам выбранный сегмент; после замера — отдельная подложка под текстом.
 */
.segmented {
  position: relative;
}
.segment,
.segmentActive {
  position: relative;
  z-index: 1;
}
.segmentThumb {
  display: none;
}
.segmented[data-ind] .segmentThumb {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: var(--ind-w);
  height: var(--ind-h);
  border-radius: 6px;
  background: var(--seg-lift);
  /* Рамка внутрь: плашка ровно размером с наведение, отступ до края — одинаковый сверху, снизу и по бокам. */
  box-shadow: inset 0 0 0 1px var(--seg-lift-border), var(--seg-lift-shadow);
  transform: translate(var(--ind-x), var(--ind-y));
  pointer-events: none;
}
.segmented[data-ind='on'] .segmentThumb {
  transition:
    transform var(--dur-base) var(--ease-in-out),
    width var(--dur-base) var(--ease-in-out);
}
.segmented[data-ind] .segmentActive {
  background: transparent;
  box-shadow: none;
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.muted {
  color: var(--muted);
  font-size: var(--fs-13);
}
.lock {
  margin-left: 6px;
  font-size: var(--fs-12);
  color: var(--muted);
}
.indent {
  padding-left: 22px !important;
  position: relative;
}
.indent::before {
  content: '└' / '';
  position: absolute;
  left: 8px;
  color: var(--muted);
}
.dim {
  opacity: 0.55;
}
.sectionTitle {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin: 18px 0 8px;
  font-size: var(--fs-15, 15px);
  font-weight: var(--w-bold);
}
.sectionHeading {
  font-size: var(--fs-15, 15px);
  font-weight: var(--w-bold);
  margin: 0;
}
/* Кнопки действий в строке таблицы стоят плотнее, чтобы не переносились. */
.table .row {
  gap: 4px 2px;
  flex-wrap: nowrap;
}

/* Всплывающее меню и поповеры. */
.menu {
  position: fixed;
  z-index: 50;
  min-width: 220px;
  max-width: min(340px, calc(100vw - 16px));
  /* Меню никогда не прокручивается: высота — по содержимому, Popover сам открывает вверх/вниз. */
  overflow: visible;
  padding: 6px 0;
  border-radius: 10px;
  background: var(--surface);
  box-shadow: var(--shadow-pop);
  animation: pop var(--dur-fast) var(--ease);
}
/*
 * Поповер-подсказка с текстом — тёмная плашка, как подсказки в Slack (любые поповеры с текстом и подсказки — на тёмном фоне). Цвета содержимого переназначены, поэтому любой текст и значки внутри читаются
 * без своих правил. Меню, списки выбора и формы остаются светлыми.
 */
.tipSurface {
  --surface: var(--tip-bg);
  --surface-2: rgb(255 255 255 / 8%);
  --surface-3: rgb(255 255 255 / 12%);
  --text: var(--tip-text);
  --text-2: var(--tip-muted);
  --muted: var(--tip-muted);
  --border: var(--tip-line);
  --border-strong: var(--tip-line);
  --accent: var(--tip-link);
  --tool-hover: rgb(255 255 255 / 10%);
  border-color: transparent;
  background: var(--tip-bg);
  color: var(--tip-text);
  box-shadow: var(--tip-shadow);
}
.tipSurface a {
  color: var(--tip-link);
}
/* Телефон: меню — лист снизу, пункты выше, чтобы попадать пальцем. */
@media (max-width: 767px) {
  /* `.menu.sheet` — на класс сильнее любого `.pop { width: … }` у окошка: лист всегда от края до края, а не «на полширины» у левого края. */
  .menu.sheet {
    top: auto;
    left: 0;
    right: 0;
    bottom: 0;
    width: auto;
    min-width: 0;
    max-width: none;
  }
  .sheet {
    z-index: 70;
    max-height: min(72vh, calc(100dvh - 80px));
    /* Лист iOS прокручивается нативно, если пунктов больше, чем места. */
    overflow-y: auto;
    /* Нативный лист iOS: от края до края, скругление только сверху, фон идёт под жест «домой». */
    padding: 0 8px env(safe-area-inset-bottom);
    border-radius: 20px 20px 0 0;
    box-shadow: 0 -2px 40px rgb(0 0 0 / 25%);
    animation: sheetUp var(--dur-base) var(--ease);
  }
  /*
   * Лист с закреплёнными шапкой и кнопками (docs/DESIGN.md, правило окон): внутри есть [data-sheet-scroll] — прокручивается
   * только он, всё остальное стоит на месте. Лист без такого блока прокручивается целиком, как раньше (длинные меню).
   */
  .sheet:has([data-sheet-scroll]) {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .sheet:has([data-sheet-scroll]) > :not([data-sheet-scroll]) {
    flex: none;
  }
  .sheet:has([data-sheet-scroll]) > :has([data-sheet-scroll]) {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    min-height: 0;
  }
  .sheet [data-sheet-scroll] {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overscroll-behavior: contain;
  }
  .sheet::before {
    content: '';
    display: block;
    width: 36px;
    height: 5px;
    margin: 6px auto 8px;
    border-radius: 3px;
    background: var(--border-strong, rgb(120 128 150 / 40%));
  }
  .sheetBackdrop {
    position: fixed;
    inset: 0;
    z-index: 69;
    background: rgb(0 0 0 / 28%);
    animation: fadeIn var(--dur-base);
  }
  .sheet .menuItem {
    min-height: 48px;
    padding: 8px 14px;
    border-radius: 12px;
    font-size: var(--fs-16);
  }
  .sheet .menuLabel {
    padding: 8px 20px 4px;
    font-size: var(--fs-14, 14px);
  }
  .sheet .menuSeparator {
    margin: 6px 0;
  }
}
.menuClosing {
  pointer-events: none;
  animation: menuOut var(--dur-instant) var(--ease-in) forwards;
}
@keyframes menuOut {
  to {
    opacity: 0;
    transform: scale(0.98);
  }
}
@media (max-width: 767px) {
  .sheet.menuClosing {
    animation: sheetDown var(--dur-base) ease forwards;
  }
  .sheetBackdropClosing {
    animation: fadeOut var(--dur-base) ease forwards;
  }
}
@keyframes sheetDown {
  to {
    transform: translateY(110%);
  }
}
@keyframes sheetUp {
  from {
    transform: translateY(100%);
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
}
/* Меню и окошки растут от своей кнопки: угол задаёт Popover (transform-origin), Apple и Radix делают так же. */
@keyframes pop {
  from {
    opacity: 0;
    transform: scale(0.96);
  }
}
/* Как в дизайн-системе Пассворка и в Notion: пункт подсвечивается скруглённой плашкой с отступом от краёв меню,
   текст стоит там же, где стоял (6 + 14 = 20 px от края). */
.menuItem {
  display: flex;
  /* Значок и переключатель стоят у ПЕРВОЙ строки подписи, а не посередине: так длинное название в две строки не уводит их вниз. */
  --menu-line: 22px;
  align-items: flex-start;
  line-height: var(--menu-line);
  /* Значок ближе к тексту, как в меню Slack и macOS. */
  gap: 9px;
  width: calc(100% - 12px);
  /* Как в меню Slack: строка 28 px вплотную, текст в 15 px от края меню (6 + 9). */
  margin: 0 6px;
  min-height: 28px;
  padding: 3px 9px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  text-align: left;
  font-size: var(--fs-15, 15px);
  cursor: pointer;
  color: var(--text);
}
.menuItem:hover,
.menuItem:focus-visible {
  background: var(--accent);
  color: var(--accent-text);
  box-shadow: none;
}
/* Синим горит только пункт под курсором. Мышь ушла с пункта, чей вложенный список открыт, — подсветки нет совсем:
   откуда список, видно по стрелке и по положению самого списка. */
.menuItem[aria-expanded='true']:not(:hover):not(:focus-visible) {
  background: transparent;
  color: var(--text);
}
.menuItem[aria-expanded='true']:not(:hover):not(:focus-visible) svg {
  color: var(--text-2);
}
/* В тёмном меню наведение — нейтральная светлая подложка, а не синяя: синий только у ссылок. */
.tipSurface .menuItem:hover,
.tipSurface .menuItem:focus-visible,
.tipSurface .menuItem[aria-expanded='true']:not(:hover):not(:focus-visible),
.tipSurface .menuItem[aria-expanded='true'] {
  background: var(--tool-hover);
  color: var(--text);
}
.tipSurface .menuItem:hover svg,
.tipSurface .menuItem:focus-visible svg {
  color: var(--text-2);
}
.tipSurface .menuItem.menuDanger:hover {
  color: var(--danger);
}
/* Вложенный список сбоку (с мышью): поверх меню, появляется без сдвига — мышь уже на месте. */
.flyout {
  z-index: 51;
  animation: flyIn var(--dur-instant) var(--ease);
}
@keyframes flyIn {
  from {
    opacity: 0;
  }
}
/* На сенсорном экране «наведение» залипает после касания — подсвечиваем только нажатие. */
@media (hover: none) {
  .menuItem:hover:not(:active) {
    background: transparent;
    color: var(--text);
  }
  .menuItem:hover:not(:active) svg {
    color: var(--muted);
  }
  .menuItem:hover:not(:active).menuDanger {
    color: var(--danger);
  }
}
.menuItem:hover svg,
.menuItem:focus-visible svg {
  color: inherit;
}
/* На синей подсветке значение справа — тем же цветом, что и подпись, чуть прозрачнее, а не серым. */
.menuItem:hover .menuHint,
.menuItem:focus-visible .menuHint {
  color: inherit;
  opacity: 0.8;
}
.menuItem svg {
  color: var(--muted);
  flex: none;
}
.menuDanger {
  color: var(--danger);
}
/* Опасный пункт: значок красный, а подсказка клавиши справа — серая, как у остальных пунктов. */
.menuItem.menuDanger svg,
.tipSurface .menuItem.menuDanger svg {
  color: var(--danger);
}
.menuItem.menuDanger .menuShortcut,
.menuItem.menuDanger:hover .menuShortcut,
.menuItem.menuDanger:focus-visible .menuShortcut {
  color: var(--muted);
}
.menuSeparator {
  height: 1px;
  /* Линия с отступами от краёв, как в Slack. */
  margin: 6px 15px;
  background: var(--border);
}
.menuLabel {
  padding: 4px 15px 6px;
  font-size: var(--fs-13);
  font-weight: var(--w-bold);
  color: var(--text-2);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.menuShortcut {
  margin-left: auto;
  font-size: var(--fs-12);
  opacity: 0.7;
}
.menuHint {
  flex: none;
  margin-left: auto;
  padding-left: 12px;
  margin-right: -6px;
  font-size: var(--fs-14, 14px);
  color: var(--muted);
  white-space: nowrap;
}
.menuLabelNowrap {
  white-space: nowrap;
}
.menuLabelEllipsis {
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.menuHint + .menuShortcut {
  margin-left: 8px;
}
.menuChevron {
  margin-left: auto;
}
.menuItem .menuChevron {
  color: var(--text-2);
}
.menuItem:hover .menuChevron,
.menuItem:focus-visible .menuChevron,
.menuItem[aria-expanded='true'] .menuChevron {
  color: inherit;
}
.menuAi {
  flex: none;
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  color: var(--accent);
}
.menuAiColumn {
  width: 16px;
  justify-content: center;
}
.menuAiColumn > span {
  margin-left: 0;
}
.menuCheckAfterAi {
  flex: none;
  width: 14px;
  height: 14px;
  margin-left: 8px;
  color: var(--text-2);
}
.menuItem:hover .menuCheckAfterAi,
.menuItem:focus-visible .menuCheckAfterAi {
  color: inherit;
}
.menuHint ~ .menuChevron,
.menuShortcut ~ .menuChevron {
  /* Значение справа — вплотную к стрелке, как в Slack (у значка стрелки свои поля внутри — подтягиваем). */
  margin-left: 0;
}
/* Вложенный список въезжает сбоку, как в мобильных меню. */
/* Образец цвета в меню (цвета документов): «A» цветом текста, фон — цветом фона. */
.menuSwatch {
  flex: none;
  display: grid;
  place-items: center;
  width: 20px;
  height: 20px;
  border: 1px solid var(--border);
  border-radius: 4px;
  font-size: var(--fs-13);
  font-weight: var(--w-bold);
  line-height: 1;
}
.menuDot {
  flex: none;
  display: grid;
  place-items: center;
  width: 16px;
  height: 16px;
}
.menuDot > span {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.menuSub {
  display: contents;
}
.menuBack {
  font-weight: var(--w-bold);
}
.menuBack svg {
  opacity: 0.6;
}

.tabs {
  display: flex;
  gap: 4px;
  /* Серая линия — тенью внутри: синяя черта выбранной вкладки ложится прямо на неё, по её нижнему краю,
     а не висит над линией (правило для всех вкладок, docs/DESIGN.md). */
  box-shadow: inset 0 -1px 0 var(--border);
  overflow-x: auto;
  scrollbar-width: none;
}
.tab,
.tabActive {
  border: 0;
  background: transparent;
  padding: 10px 10px 9px;
  font-size: var(--fs-14, 14px);
  font-weight: var(--w-medium);
  color: var(--text-2);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  white-space: nowrap;
}
.tab:hover {
  color: var(--text);
}
/* Вкладка со значком (виды базы): значок и подпись на одной оси. */
.tabIcon {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.tabActive {
  /* Выбранная — чёрным, без жирного (DESIGN.md, «Вкладки»): ширина не меняется, ничего не прыгает. */
  color: var(--text);
  border-bottom-color: var(--accent);
}
/* Число у вкладки, как в Пассворке («Пользователи 4»): серая плашка на базовой линии подписи. */
.tabCount {
  display: inline-block;
  min-width: 20px;
  margin-left: 6px;
  padding: 0 6px;
  border-radius: 6px;
  background: var(--surface-2);
  color: var(--text-2);
  font-size: var(--fs-12);
  font-weight: var(--w-medium);
  line-height: 18px;
  text-align: center;
  vertical-align: 1px;
}

.toast {
  position: fixed;
  left: 50%;
  bottom: calc(28px + env(safe-area-inset-bottom));
  transform: translateX(-50%);
  z-index: 60;
  display: flex;
  align-items: center;
  gap: 14px;
  width: max-content;
  max-width: min(560px, calc(100vw - 32px));
  padding: 10px 12px 10px 16px;
  border-radius: 12px;
  background: var(--tip-bg);
  color: var(--tip-text);
  font-size: var(--fs-14, 14px);
  font-weight: var(--w-medium);
  box-shadow: var(--tip-shadow);
  animation: toastIn var(--dur-base) var(--ease);
}
@keyframes toastIn {
  from {
    opacity: 0;
    transform: translate(-50%, 10px) scale(0.98);
  }
}
.toastLeaving {
  pointer-events: none;
  animation: toastOut var(--dur-base) ease forwards;
}
@keyframes toastOut {
  to {
    opacity: 0;
    transform: translate(-50%, 6px);
  }
}
/* Телефон: над полем ввода и нижними вкладками, чтобы ничего не закрывать. */
@media (max-width: 767px) {
  .toast {
    bottom: calc(92px + env(safe-area-inset-bottom));
    border-radius: 12px;
  }
  /*
   * Где есть нижние вкладки, справа над ними — круглая «+» (54 px, отступ 16 px, на 14 px выше вкладок, см. fab.module.css).
   * Уведомление встаёт слева от неё на одном уровне: справа остаётся место под «+» и зазор 12 px, текст переносится на две строки.
   */
  :global(body:has([data-tabs])) .toast {
    left: 16px;
    right: calc(16px + 54px + 12px);
    bottom: calc(56px + 14px + env(safe-area-inset-bottom));
    transform: none;
    width: auto;
    max-width: none;
    min-height: 54px;
    gap: 8px;
    padding: 8px 6px 8px 12px;
    /* Спокойнее: без чёрной тени, цвет темнее подсказки, скругление как у карточек быстрого доступа. */
    background: color-mix(in srgb, var(--tip-bg) 72%, #000);
    box-shadow: 0 0 0 1px var(--tip-line);
    animation-name: toastInPhone;
  }
  :global(body:has([data-tabs])) .toastLeaving {
    animation-name: toastOutPhone;
  }
  :global(body:has([data-tabs])) .toastAction {
    padding: 6px;
  }
}
@keyframes toastInPhone {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.98);
  }
}
@keyframes toastOutPhone {
  to {
    opacity: 0;
    transform: translateY(6px);
  }
}
.toastText {
  min-width: 0;
  overflow: hidden;
  display: -webkit-box;
  /* Путь в системные настройки показываем целиком: до четырёх строк, без многоточия посреди фразы. */
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
.toastAction {
  flex: none;
  padding: 4px 10px;
  border: 0;
  border-radius: 4px;
  background: var(--tip-line);
  color: var(--tip-text);
  font-weight: var(--w-bold);
  cursor: pointer;
}
.dialogWide {
  width: min(560px, calc(100vw - 32px));
}
/* Заголовок и кнопки не прокручиваются никогда: прокручивается только `.dialogScroll`. */
.dialogPinned[open] {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.dialogPinned .dialogBody {
  flex: 1;
  min-height: 0;
}
.dialogScroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  margin: 0 -28px;
  padding: 0 28px;
}
/* Окно без своего заголовка (содержимое рисует его само). */
.dialogBare {
  width: min(680px, calc(100vw - 32px));
  overflow: hidden;
}
.dialogBare.dialogLarge,
.dialogWide.dialogLarge {
  width: min(960px, calc(100vw - 32px));
}
.dialogBare.dialogLarge.dialogLarge.dialogNarrow {
  width: min(720px, calc(100vw - 32px));
}
.dialogLarge.dialogLarge.dialogXl {
  width: min(880px, calc(100vw - 32px));
}
.dialogBare.dialogSmall.dialogSmall {
  width: min(480px, calc(100vw - 32px));
}
/* Праздничное окно: узкое, с большим скруглением. */
.dialogRound.dialogRound {
  width: min(440px, calc(100vw - 32px));
  border-radius: 28px;
}
@media (min-width: 768px) {
  .dialogRound.dialogRound.dialogRoomy {
    width: min(520px, calc(100vw - 32px));
  }
}
/* Компактное окно: отборы и быстрые выборы — 400 px и малые поля. */
.dialogCompact.dialogCompact {
  width: min(400px, calc(100vw - 32px));
}
.dialogCompact.dialogSnug {
  width: min(376px, calc(100vw - 32px)); /* чуть уже карточки входа (400): края не совпадают */
}
.dialogCompact .dialogBody {
  --dlg-pt: 14px;
  --dlg-pb: 16px;
  padding: var(--dlg-pt) 16px var(--dlg-pb);
  gap: 8px;
}
/* Поиск: окно у верхнего края, как раскрытая строка поиска. */
.dialogTop {
  margin-top: 6px;
}
@media (max-width: 767px) {
  .dialog,
  .dialogBare.dialogLarge,
  .dialogWide.dialogLarge,
  .dialogBare.dialogLarge.dialogLarge.dialogNarrow,
  .dialogLarge.dialogLarge.dialogXl,
  .dialogBare.dialogSmall.dialogSmall,
  .dialogCompact.dialogCompact,
  .dialogCompact.dialogSnug {
    width: 100vw;
    max-width: 100vw;
    max-height: 92vh;
    margin: auto 0 0;
    border-radius: 16px 16px 0 0;
  }
  .dialogRound.dialogRound {
    width: 100vw;
    border-radius: 28px 28px 0 0;
  }
  .dialogBody {
    --dlg-pt: 18px;
    --dlg-pb: calc(20px + env(safe-area-inset-bottom));
    padding: var(--dlg-pt) 16px var(--dlg-pb);
  }
  .dialogTop {
    margin: 0 0 auto;
    border-radius: 0 0 14px 14px;
  }
  .dialog.dialogFull {
    height: 100dvh;
    max-height: 100dvh;
    margin: 0;
    border-radius: 0;
  }
}

/* Выпадающий список (SelectField): поле-кнопка и всплывающий список вместо системного <select>. */
.selectTrigger {
  display: flex;
  align-items: center;
  gap: 8px;
  text-align: left;
  cursor: pointer;
  user-select: none;
}
.selectTrigger.input {
  padding-right: 10px;
}
.selectTrigger[aria-expanded='true'] {
  border-color: var(--accent);
  background: var(--surface);
  box-shadow: var(--focus);
}
.selectTrigger:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.selectTrigger:disabled:hover {
  border-color: var(--border);
}
.selectValue {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.selectIcon {
  display: inline-flex;
  flex: none;
  color: var(--muted);
}
.selectPlaceholder {
  color: var(--muted);
}
.selectChevron {
  flex: none;
  color: var(--muted);
  transition: transform var(--dur-fast) var(--ease), color var(--dur-fast);
}
.selectTrigger:hover:not(:disabled) .selectChevron {
  color: var(--text-2);
}
.selectTrigger[aria-expanded='true'] .selectChevron {
  color: var(--accent);
  transform: rotate(180deg);
}
/* Маленькое поле — в строке формы (вид своего поля в Пассворке). */
.selectCompact {
  height: 32px;
  padding: 0 8px 0 10px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--surface);
  color: var(--text-2);
  font-size: var(--fs-13);
  gap: 6px;
  transition: border-color var(--dur-fast), box-shadow var(--dur-fast);
}
.selectCompact:hover:not(:disabled) {
  border-color: color-mix(in srgb, var(--text) 30%, var(--border-strong));
}
.selectCompact:focus-visible {
  border-color: var(--accent);
}
.selectTrigger[aria-invalid='true'] {
  border-color: var(--danger);
}

.selectPopup {
  display: flex;
  flex-direction: column;
  min-width: 200px;
  max-width: calc(100vw - 16px);
  max-height: calc(100vh - 16px);
  overflow: hidden;
  padding: 0;
}
.selectBody {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
}
.selectTitle {
  display: none;
}
.selectSearch {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 6px 6px 0;
  padding: 0 10px;
  border-radius: 6px;
  background: var(--surface-2);
  color: var(--muted);
  box-shadow: inset 0 0 0 1px var(--border);
  transition: box-shadow var(--dur-fast);
}
.selectSearch:focus-within {
  background: var(--surface);
  box-shadow: inset 0 0 0 1px var(--accent), var(--focus);
}
.selectSearch svg {
  flex: none;
}
.selectSearchInput {
  flex: 1;
  min-width: 0;
  height: 34px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--text);
  font-size: var(--fs-14, 14px);
  outline: none;
}
.selectSearchInput:focus-visible {
  box-shadow: none;
}
.selectList {
  flex: 0 1 auto;
  min-height: 0;
  max-height: 320px;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 6px;
}
.selectListTall {
  height: 320px;
}
.selectOption {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 34px;
  padding: 6px 10px;
  border-radius: 6px;
  color: var(--text);
  font-size: var(--fs-14, 14px);
  line-height: var(--lh-20, 20px);
  cursor: pointer;
  scroll-margin: 6px;
}
.selectOption[aria-selected='true'] {
  background: var(--accent-softer);
}
.selectOptionActive,
.selectOptionActive[aria-selected='true'] {
  background: var(--accent-soft);
}
.selectOptionLabel {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.selectCheck {
  flex: none;
  color: var(--accent);
}
.selectEmpty {
  padding: 24px 12px;
  text-align: center;
  color: var(--muted);
  font-size: var(--fs-14, 14px);
}
/* Телефон: лист снизу с заголовком и крупными строками. */
@media (max-width: 767px) {
  .sheet.selectPopup {
    max-width: none;
    max-height: min(80vh, calc(100dvh - 40px));
    padding: 0 0 4px;
  }
  .sheet .selectTitle {
    display: block;
    padding: 14px 20px 6px;
    color: var(--text-2);
    font-size: var(--fs-14, 14px);
    font-weight: var(--w-bold);
  }
  .sheet .selectSearch {
    margin: 4px 12px 2px;
    padding: 0 12px;
    border-radius: 10px;
  }
  .sheet .selectSearchInput {
    height: 44px;
    font-size: var(--fs-16);
  }
  .sheet .selectList {
    max-height: min(56vh, calc(100dvh - 160px));
    padding: 4px 8px;
  }
  .sheet .selectListTall {
    height: min(56vh, calc(100dvh - 160px));
  }
  .sheet .selectOption {
    min-height: 48px;
    padding: 10px 12px;
    border-radius: 10px;
    font-size: var(--fs-16);
    line-height: var(--lh-22, 22px);
  }
  .sheet .selectOptionLabel {
    white-space: normal;
  }
  .sheet .selectCheck {
    width: 20px;
    height: 20px;
  }
}
/* На сенсорном экране наведение залипает — подсвечиваем только выбранный пункт. */
@media (hover: none) {
  .selectOptionActive:not([aria-selected='true']) {
    background: transparent;
  }
  .selectOptionActive:active {
    background: var(--accent-soft);
  }
}

/* Пункт с пояснением второй строкой (уведомления, как в Slack): значок — у первой строки, выбранный — синим. */
.menuItemTall {
  align-items: flex-start;
  padding-top: 8px;
  padding-bottom: 8px;
}
/* Первая строка — 22 px: значок 16 → отступ 3, галочка и стрелка 14 → 4, переключатель 18 → 2, аватар и образец 20 → 1. */
.menuItem > svg {
  margin-top: calc((var(--menu-line) - 16px) / 2);
}
.menuItem > svg.menuChevron,
.menuItem > svg.menuCheckAfterAi {
  margin-top: calc((var(--menu-line) - 14px) / 2);
}
.menuItem > .menuSwitch {
  margin-top: calc((var(--menu-line) - 18px) / 2);
}
.menuItem > .menuSwatch,
.menuItem > .menuAvatar {
  margin-top: calc((var(--menu-line) - 20px) / 2);
}
.menuAvatar {
  display: inline-flex;
  flex: none;
}
.menuItem > .menuDot {
  margin-top: calc((var(--menu-line) - 16px) / 2);
}
.menuItem > .menuAi {
  height: var(--menu-line);
}
.menuTwoLines {
  display: grid;
  gap: 1px;
  min-width: 0;
}
.menuDescription {
  font-size: var(--fs-13);
  line-height: 18px;
  color: var(--muted);
}
/* Выбранный пункт — как в Notion и Slack: текст обычного цвета, выбор показывает только галочка справа. */
.menuChecked .menuChevron {
  color: var(--text);
}
.menuItem:hover .menuDescription,
.menuItem:focus-visible .menuDescription {
  color: inherit;
  opacity: 0.85;
}

/* Стрелка рядом с текстом: на 1 px ниже середины строки (оптический центр строчных). См. TextCaret. */
.textCaret {
  flex: none;
  display: inline-grid;
  place-items: center;
  translate: 0 1px;
}

/* «Что это и как работает» у пункта меню: тёмное окошко сбоку при наведении, как подсказки Slack. Токены --tip-* — общие для подсказок (дизайн-система). */
.menuAbout {
  position: fixed;
  z-index: 52;
  display: grid;
  gap: 6px;
  width: 240px;
  max-width: calc(100vw - 16px);
  padding: 7px 10px 8px;
  border-radius: 8px;
  background: var(--tip-bg, #1a1c1f);
  box-shadow: var(--tip-shadow, 0 4px 12px rgb(0 0 0 / 22%));
  pointer-events: none;
  animation: flyIn var(--dur-fast) var(--ease);
  transition: opacity var(--dur-fast) var(--ease);
}
/* Окошко с картинкой (темы оформления) — карточка как в Bridge: цвета меню, мягкая тень, миниатюра и подпись под ней. */
/* Внешний радиус = внутренний (10, миниатюра) + поле (6): углы карточки и картинки сочетаются, как в Bridge. */
.menuPreview {
  display: block;
  width: auto;
  padding: 6px;
  border-radius: 16px;
  background: var(--surface);
  box-shadow: var(--shadow-pop);
  font-size: 0;
}
/* Меню гаснет (Esc, щелчок мимо) — окошко гаснет вместе с ним, а не пропадает рывком. */
body:has(.menuClosing) .menuAbout {
  opacity: 0;
}
.menuAboutHead {
  margin: 0;
  font-size: var(--fs-13);
  line-height: 19px;
  font-weight: var(--w-bold);
  color: var(--tip-text, #fff);
}
.menuAboutRule {
  height: 1px;
  margin: 0;
  border: 0;
  background: rgb(255 255 255 / 18%);
}
.menuAboutPage .menuAboutHead {
  color: var(--text);
}
.menuAboutPage .menuAboutRule {
  background: var(--border);
}
.menuAboutText {
  margin: 0;
  font-size: var(--fs-13);
  line-height: 19px;
  color: var(--tip-text, #fff);
}
/* На телефоне «что это» — страницей в самом листе меню, цветами листа. */
.menuAboutPage .menuAboutText {
  color: var(--text-2);
}
/* Телефон и сенсорный экран: строка пункта и значок «ⓘ» справа. */
.menuAboutRow {
  display: flex;
  align-items: stretch;
  gap: 2px;
  margin: 0 6px;
}
.menuAboutRow > .menuItem {
  flex: 1;
  width: auto;
  min-width: 0;
  margin: 0;
}
.menuAboutButton {
  flex: none;
  display: grid;
  place-items: center;
  width: 40px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--muted);
  cursor: pointer;
}
.menuAboutButton:hover,
.menuAboutButton:active,
.menuAboutButton:focus-visible {
  background: var(--surface-3);
  color: var(--text);
}
.menuAboutPage {
  display: grid;
  gap: 8px;
  padding: 8px 15px 10px;
}
@media (max-width: 767px) {
  .sheet .menuAboutButton {
    width: 48px;
    border-radius: 12px;
  }
  .menuAboutPage {
    padding: 8px 20px 12px;
  }
  .menuAboutPage .menuAboutText {
    font-size: var(--fs-15);
    line-height: 22px;
  }
}

/* Силуэты строк списка при загрузке. */
.skelList {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 0;
}
.skelRow {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 48px;
  padding: 0 8px;
}
.bone {
  display: block;
  height: 12px;
  border-radius: 4px;
  background: linear-gradient(90deg, var(--surface-2), var(--border), var(--surface-2));
  background-size: 200% 100%;
  animation: bone-shimmer 1.4s linear infinite;
}
.boneIcon {
  flex: none;
  width: 28px;
  height: 28px;
  border-radius: 6px;
}
.boneText {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.boneSub {
  height: 10px;
}
@keyframes bone-shimmer {
  to {
    background-position: -200% 0;
  }
}
@media (prefers-reduced-motion: reduce) {
  .bone {
    animation: none;
  }
}

/* Переключатель в строке меню страницы (как в меню «⋯» Notion). */
.menuSwitch {
  position: relative;
  flex: none;
  margin-left: auto;
  width: 30px;
  height: 18px;
  border-radius: 9px;
  background: var(--border-strong);
  transition: background-color var(--dur-fast);
}
.menuSwitch::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 2px rgb(0 0 0 / 25%);
  transition: transform var(--dur-fast);
}
.menuSwitchOn {
  background: #2f80ed;
}
.menuSwitchOn::after {
  transform: translateX(12px);
}
.menuItem:hover .menuSwitch:not(.menuSwitchOn),
.menuItem:focus-visible .menuSwitch:not(.menuSwitchOn) {
  background: rgb(255 255 255 / 35%);
}
/* Подпись внизу меню: мелко, серым, без нажатий. */
.menuNote {
  padding: 4px 15px 6px;
  font-size: var(--fs-13);
  line-height: 1.4;
  color: var(--text-2);
  cursor: default;
}
/* «Поиск действий…» над списком меню. */
.menuSearch {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 2px 8px 6px;
  padding: 0 9px;
  height: 30px;
  border-radius: 6px;
  box-shadow: inset 0 0 0 1px var(--border-strong);
  color: var(--text-2);
}
.menuSearch:focus-within {
  box-shadow: inset 0 0 0 2px #2f80ed;
}
.menuSearchInput {
  flex: 1;
  min-width: 0;
  height: 100%;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--text);
  font: inherit;
  font-size: var(--fs-15, 15px);
}
.menuSearchInput::placeholder {
  color: var(--text-2);
}
.menuItem.menuDisabled,
.menuItem.menuDisabled:hover,
.menuItem.menuDisabled:focus-visible {
  background: transparent;
  color: var(--text);
  opacity: 0.4;
  cursor: default;
}
.menu.menuTall {
  /* Единственное исключение — длинные каталоги (типы свойств, действия документа с поиском). */
  max-height: min(680px, calc(100vh - 16px));
  overflow-y: auto;
}

/* Низкое окно: профильное и другие длинные меню сжимают строку, но не получают прокрутку. */
@media (min-width: 768px) and (max-height: 560px) {
  .menu:not(.menuTall) .menuItem {
    min-height: 24px;
    padding-block: 1px;
  }
  .menu:not(.menuTall) .menuSeparator {
    margin-block: 3px;
  }
}

.menu.menuWide {
  max-width: min(560px, calc(100vw - 16px));
}

/* Иконка остаётся первым потомком и во время загрузки (внутри .busyLabel),
   поэтому текст кнопки не прыгает при клике. */
.button:has(> svg:first-child):not(.icon),
.button:has(> .busyLabel > svg:first-child):not(.icon) {
  padding-left: 14px;
  gap: 7px;
}
.small:has(> svg:first-child):not(.icon),
.small:has(> .busyLabel > svg:first-child):not(.icon) {
  padding-left: 10px;
  gap: 6px;
}
.button:not(.icon) > svg,
.button:not(.icon) > .busyLabel > svg { stroke-width: 2.1; }

.errorNotice {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
}
.errorNoticeWhat {
  font-weight: var(--w-700, 700);
}
.errorNoticeAvoid {
  color: var(--text-2);
}
.errorNoticeActions {
  margin-top: 6px;
}

/* Плитки: пять равных колонок, значок над подписью, рамка; выбранная — мягкий акцент. Значки не прячутся и на телефоне. */
.segmentedTiles {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  grid-auto-flow: column;
  gap: 6px;
  padding: 0;
  border: 0;
  background: transparent;
}
.segmented.segmentedTiles > .segment,
.segmented.segmentedTiles > .segmentActive {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 5px;
  min-height: 56px;
  padding: 9px 2px 8px;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  font-size: var(--fs-12);
}
.segmented.segmentedTiles > .segment > svg,
.segmented.segmentedTiles > .segmentActive > svg {
  display: block;
}
.segmented.segmentedTiles[data-ind] > .segmentActive,
.segmented.segmentedTiles > .segmentActive {
  background: var(--accent-soft);
  border-color: var(--accent);
  color: var(--accent-ink);
}
.segmentTileName {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.segmented.segmentedTiles .segmentThumb {
  display: none;
}

/* Статус доставки под сообщением (DeliveryStatus): одна строка, цвет только у значка и заголовка. */
.delivery {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2px var(--gap);
  margin-top: 6px;
  font-size: var(--fs-13);
  color: var(--danger);
}
.deliveryTitle {
  font-weight: var(--w-medium);
}
.deliveryAction {
  padding: 2px 0;
  border: 0;
  background: none;
  color: var(--accent-ink);
  font: inherit;
  cursor: pointer;
}
.deliveryAction:hover:not(:disabled) {
  text-decoration: underline;
}
.deliveryAction:disabled {
  color: var(--muted);
  cursor: default;
}
.deliveryPop {
  box-sizing: border-box;
  width: 300px;
  min-width: 0;
  padding: 10px 12px;
  font-size: var(--fs-13);
  line-height: 1.45;
}
.deliveryBody {
  overflow-wrap: anywhere;
}
.deliveryFix {
  display: inline-block;
  margin-top: 10px;
  padding: 5px 10px;
  border: 1px solid var(--tip-line);
  border-radius: 8px;
  color: var(--tip-text);
  font-weight: var(--w-medium);
  text-decoration: none;
}
.deliveryPop .deliveryFix:hover,
.deliveryPop .deliveryFix:focus-visible {
  background: var(--tool-hover);
  text-decoration: none;
}

/* Плашка с роликом у пункта списка и у поля: тёмно-серая, как все подсказки; ролик внутри — в цветах темы. */
.previewTip {
  position: fixed;
  z-index: 60;
  width: min(580px, calc(100vw - 16px));
  padding: 6px 6px 8px;
  border-radius: 12px;
  background: var(--tip-bg, #1a1c1f);
  box-shadow: var(--tip-shadow, 0 4px 12px rgb(0 0 0 / 22%));
  pointer-events: none;
  animation: flyIn var(--dur-fast) var(--ease);
}
